import { FunctionComponent } from 'react';

import BtnNbk from '../../shared/components/BtnNBK';

import { Flex } from 'antd';
import '../../shared/css/fontStyle.css';
import '../css/style.css';
import { characterStyle } from '../utils/characterStyle';

interface IntroProps {
  next: () => void;
}

const IntroTeacher: FunctionComponent<IntroProps> = (props: IntroProps) => {
  const { next } = props;
  return (
    <div className="main">
      <div className="title" style={{ textAlign: 'center' }}>
        Bienvenue sur Nabook !
      </div>
      <Flex className="wrapper" style={{ justifyContent: 'center', alignItems: 'center' }}>
        <div
          style={{
            background: '#FECF03',
            borderRadius: 8,
            paddingBottom: 12,
            paddingRight: 12,
            maxWidth: 700,
          }}>
          <Flex
            style={{
              background: '#3E276F',
              borderRadius: 8,
              alignItems: 'center',
              justifyContent: 'center',
              maxWidth: 700,
              marginTop: -12,
              marginLeft: -12,
            }}>
            <img
              style={characterStyle(255 / 385, { left: -27 })}
              src={require('../../assets/characters/maestro.png')}
              alt=""
            />
            <Flex vertical style={{ marginRight: 40 }}>
              <div className="serie-title" style={{ marginBottom: 8 }}>
                QUART D’HEURE LECTURE
              </div>
              <div className="resume">
                Animez des temps de lecture à voix haute dans votre classe. projetez l’écran au tableau répartissez les locuteurs à
                interpréter toute la classe suit la lecture !
              </div>
            </Flex>
          </Flex>
        </div>
      </Flex>
      <BtnNbk style={{ marginTop: 12 }} txt="Constituer ma pile à lire" onClick={next} />
    </div>
  );
};

export default IntroTeacher;
